import React from 'react';
import styled, { css } from 'styled-components';

import { useTranslation } from 'react-i18next';

import InputText from '@components/Inputs/InputText';
import Select from '@components/Forms/Select';
import { docTypesByCountry } from '@helpers/user';
import { isCountryPeruOrColombia } from 'constants/regions';

const StyledInputText = styled(InputText)`
  width: 100%;
`;

const InputContainer = styled.div(
  ({ theme }) => css`
    position: relative;
    display: flex;
    height: 56px;
    div:nth-child(1) {
      max-width: 117px;
      margin-right: 8px;
      > div {
        margin-left: 0px;
      }
    }
    div:nth-child(2) {
      padding-left: 8px;
      flex: auto;
      p {
        margin-left: 0px;
        display: none;
        ${theme.breakpoint('md')} {
          display: flex;
        }
      }
    }
  `
);

const StyleHelperText = styled.p(
  ({ theme, isError }) => css`
    /* figma */
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;

    color: ${isError ? theme.colors.error : theme.colors.gray600};

    /* Style element p of InputText */
    font-size: 0.75rem;
    line-height: 1.66;
    letter-spacing: 0.03333em;

    position: absolute;
    top: 100%;
    margin: 3px 0 0 0;
    ${theme.breakpoint('md')} {
      display: none;
    }
  `
);

export const DocumentInput = ({ handleChange, formValues, errors, disabled }) => {
  const { t } = useTranslation();

  if (docTypesByCountry.length <= 1)
    return (
      <StyledInputText
        onChange={handleChange}
        variant="outlined"
        label={t('common.docType')}
        id="doc_number"
        value={formValues.doc_number}
        error={errors.doc_number}
        helperText={errors.doc_number}
      />
    );

  const helperTextDocNumber =
    errors.doc_number || t('Onboarding.MerchantOnboarding.userInviteData.docNumber.helperText');
  return (
    <InputContainer>
      <Select
        id="doc_type"
        myname="doc_type"
        value={formValues.doc_type}
        variant="outlined"
        handleMyChange={handleChange}
        options={docTypesByCountry}
        disabled={disabled}
      />
      <InputText
        handleChange={handleChange}
        variant="outlined"
        label={t('common.docNumber')}
        id="doc_number"
        value={
          isCountryPeruOrColombia
            ? formValues.doc_number.replace(/[^A-Za-z0-9]/, '')
            : formValues.doc_number
        }
        error={errors.doc_number}
        helperText={helperTextDocNumber}
        disabled={disabled}
      />
      <StyleHelperText isError={!!errors.doc_number}>{helperTextDocNumber}</StyleHelperText>
    </InputContainer>
  );
};
